import { useEffect } from 'react';

interface SEOHeadProps {
  schemas: object[];
}

/**
 * Injects Schema.org JSON-LD scripts into <head> at mount,
 * removes them on unmount.
 */
const SEOHead = ({ schemas }: SEOHeadProps) => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = schemas.map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SEOHead;
